export function absCeil(number) {
    return number < 0 ? Math.floor(number) : Math.ceil(number);
}
//# sourceMappingURL=abs-ceil.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-bootstrap/chronos/utils/abs-ceil.js
// module id = ./node_modules/ngx-bootstrap/chronos/utils/abs-ceil.js
// module chunks = vendor